import { ReactNode } from "react";
import { AitBorderRow } from "./AitBorderRow";
import { AitColumnAnnotationPreviewRow } from "./AitColumnAnnotationPreviewRow";
import { AitHeaderRow } from "./AitHeaderRow";
import { useTableContext } from "./TableContextProvider";
import { AitHeaderRowData, AitRowType, AitTablePosition } from "./functions/interface";

/**
 * Render the table header section including header rows and optional
 * annotation preview.
 *
 * @template T - Header payload type
 */
export const AitHeader = <T,>(): ReactNode => {
  const { state } = useTableContext<T>();
  const thisHeader = state?.processedTableData?.headerData;
  const id = `${state?.id}-header`;
  const rows: AitHeaderRowData<T>[] = thisHeader ? thisHeader.rows : [];
  const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";

  return !state ? null : (
    <thead id={id}>
      <AitBorderRow
        id={`${id}-top-border`}
        spaceAfter={true}
        topBorder
      />
      {showAnnotationPreview && <AitColumnAnnotationPreviewRow />}
      {thisHeader &&
        rows.map((row, ri) => (
          <AitHeaderRow
            key={row.aitid}
            location={{
              tableSection: AitRowType.header,
              position: AitTablePosition.headerRow,
              rowGroup: 0,
              rowGroupId: thisHeader.aitid,
              rowId: row.aitid,
              rowRepeat: undefined,
              row: ri,
              isRepeat: false,
            }}
          />
        ))}
      {
        // No border required if thisHeader is false/undefined
        !thisHeader || rows.length === 0 ? null : (
          <AitBorderRow
            id={`${id}-midtable-border`}
            spaceBefore={true}
            spaceAfter={true}
          />
        )
      }
    </thead>
  );
};

AitHeader.displayName = "AitHeader";
